import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { formValueSelector, getFormValues } from 'redux-form';
import get from 'lodash.get';
import FormField from './FormField';
import getValue from './getValue';
const REDUX_FORM_NAME = 'record-form';

export const DependentImageInput = ({ children, show, dependsOn, value, toValue, resolve, ...props }) => {
	if (!show ) {
		return null;
	}
	return (
		<div key={children.props.source} style={children.props.style} className={`aor-input-${children.props.source}`}>
			<FormField input={children} toValue={toValue} {...props} />
		</div>
	);
};

DependentImageInput.propTypes = {  
	children: PropTypes.node.isRequired,
	show: PropTypes.bool.isRequired,
	dependsOn: PropTypes.any,
	value: PropTypes.any,
	resolve: PropTypes.func,
	toValue: PropTypes.string
};

export const mapStateToProps = (state, { resolve, dependsOn, value , toValue}) => {
	if (resolve && (dependsOn === null || typeof dependsOn === 'undefined')) {
		const values = getFormValues(REDUX_FORM_NAME)(state);
		return { show: resolve(values) };
	}

	let formValue;
	// get the current form values from redux-form
	if (Array.isArray(dependsOn)) {
		// We have to destructure the array here as redux-form does not accept an array of fields
		formValue = formValueSelector(REDUX_FORM_NAME)(state, ...dependsOn);
	} else {
		formValue = formValueSelector(REDUX_FORM_NAME)(state, dependsOn);
	}
	
	// for check name empty
	
	
	if( formValue && formValue.trim().length <= 0 ){
		return {show :false}
	}

	if (resolve) {
		return { show: resolve(formValue, dependsOn), toValue: formValue };
	}
	
	if (Array.isArray(dependsOn) && Array.isArray(value)) {
		return {
			show: dependsOn.reduce((acc, s, index) => acc && get(formValue, s) === value[index], true),
			toValue: formValue
		};
	}
	
	if (typeof value === 'undefined') {
		if (Array.isArray(dependsOn)) {
			return {
				show: dependsOn.reduce((acc, s) => acc && !!getValue(formValue, s), true),
				toValue: formValue
			};
		}
		return { show: !!formValue, toValue: formValue};
	}
	
	return { show: formValue === value, toValue: formValue };
};

export default connect(mapStateToProps)(DependentImageInput);


// WEBPACK FOOTER //
// ./src/components/image/DependentImageInput.js